import { TimeDisplayFormatSchema, TimeDisplayFormatType } from "../types";
import { round } from "./round";

export const formatTimeString = (
  time: number | null | undefined,
  timeDisplayFormat: TimeDisplayFormatType = TimeDisplayFormatSchema.enum.HH_MM_SS,
) => {
  if (time === null || time === undefined) {
    return "-";
  }

  switch (timeDisplayFormat) {
    case TimeDisplayFormatSchema.enum.HH_MM_SS:
      return formatTimeStringHHMMSS(time);
    case TimeDisplayFormatSchema.enum.DECIMAL_MINUTES:
      return formatTimeStringDecimalMinutes(time);
    case TimeDisplayFormatSchema.enum.DECIMAL_HOURS:
      return formatTimeStringDecimalHours(time);
  }
};

const formatTimeStringDecimalMinutes = (time: number) => {
  return `${String(round(time, 2)).replace(".", ",")} min`;
};

const formatTimeStringDecimalHours = (time: number) => {
  return `${String(round(time / 60, 2)).replace(".", ",")} h`;
};

const formatTimeStringHHMMSS = (time: number) => {
  const totalSeconds = round(time * 60);
  const hours = Math.floor(totalSeconds / 3600);
  const minutes = Math.floor((totalSeconds % 3600) / 60);
  const seconds = totalSeconds % 60;

  return [hours, minutes, seconds].map((unit) => String(unit).padStart(2, "0")).join(":");
};
